function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24204"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17914",
    d: "M12 4v16m8-8H4",
    transform: "translate(.5 -.5)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  })));
};

export default SvgPlus;